import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import { NEW_STUDENT_ID } from 'common.components/students/students.constants';

import * as constants from './constants';

const initialState = {
    newStudent: null,
    loadingStatus: LOADING_STATUSES.UNSENT,
    editStudentNameStatus: LOADING_STATUSES.SUCCESS,
    currentEditingStudentIndex: null,
    isAddingNewStudent: false,
    migratingStudents: {},
    controlsStatus: true,
    submitting: false,
    editingStudentNames: {},
    convertPassportsStatus: LOADING_STATUSES.UNSENT,
    currentPassportChangeStudentIndex: null,
    studentChangePassportStatus: LOADING_STATUSES.UNSENT,
    passportClasses: {},
};

const reducer = (state = initialState, action) =>
    // eslint-disable-next-line complexity
    produce(state, (draft) => {
        switch (action.type) {
            case constants.GET_NEW_STUDENT_LOGIN_REQUEST:
                draft.isAddingNewStudent = true;
                // draft.controlsStatus = true;
                break;

            case constants.GET_NEW_STUDENT_LOGIN_SUCCESS: {
                const { login, loginId } = action;

                draft.newStudent = {
                    id: NEW_STUDENT_ID,
                    loginId: loginId,
                    login: login,
                    firstName: '',
                    lastName: '',
                    isNew: true,
                };
                break;
            }

            case constants.CANCEL_ADDING_NEW_STUDENT:
                draft.newStudent = null;
                draft.editingStudentNames[NEW_STUDENT_ID] = null;
                draft.isAddingNewStudent = false;
                // TODO вернуть, когда будут ручки добавления по 1
                // draft.controlsStatus = false;
                break;

            case constants.SAVE_NEW_STUDENT_REQUEST:
                draft.isAddingNewStudent = true;
                draft.controlsStatus = true;
                break;

            case constants.SAVE_NEW_STUDENT_SUCCESS:
                draft.editingStudentNames[NEW_STUDENT_ID] = null;
                draft.newStudent = null;
                draft.isAddingNewStudent = false;
                // TODO: вернуть на false когда будут ручки добавления по 1
                // draft.controlsStatus = false;
                draft.currentPasswordChangeStudentIndex = null;
                break;

            case constants.SET_CURRENT_EDITING_STUDENT_INDEX: {
                draft.currentEditingStudentIndex = action.id;
                break;
            }

            case constants.SET_CURRENT_EDITING_STUDENT_NAME: {
                draft.editingStudentNames[action.id] = action.name;
                break;
            }

            case constants.EDIT_STUDENT_NAME_REQUEST:
                // TODO: вернуть, когда будут ручки добавления по 1
                // draft.controlsStatus = false;
                draft.editStudentNameStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.EDIT_STUDENT_NAME_SUCCESS:
                draft.editStudentNameStatus = LOADING_STATUSES.SUCCESS;
                draft.currentEditingStudentIndex = null;
                draft.editingStudentNames[action.id] = null;
                break;

            case constants.EDIT_STUDENT_NAME_ERROR:
                draft.editStudentNameStatus = LOADING_STATUSES.ERROR;
                draft.currentEditingStudentIndex = null;
                draft.editingStudentNames[action.id] = null;
                draft.isAddingNewStudent = false;
                break;

            case constants.DELETE_STUDENT_REQUEST:
                // TODO: вернуть, когда будут ручки добавления по 1
                // draft.controlsStatus = false;
                break;

            case constants.SUBMITTING:
                draft.submitting = action.isSubmitting;
                break;

            case constants.REQUESTING_LOGIN:
                draft.requestingLogin = action.isRequestingLogin;
                break;

            case constants.CONVERT_STUDENTS_PASSPORT_REQUEST:
                draft.convertPassportsStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.CONVERT_STUDENTS_PASSPORT_SUCCESS:
                draft.convertPassportsStatus = LOADING_STATUSES.SUCCESS;
                break;

            case constants.CONVERT_STUDENTS_PASSPORT_ERROR:
                draft.convertPassportsStatus = LOADING_STATUSES.ERROR;
                break;

            case constants.CONVERT_STUDENT_PASSPORT_REQUEST:
                if (action.user) {
                    draft.currentPassportChangeStudentIndex = action.user.id;
                }
                draft.studentChangePassportStatus = LOADING_STATUSES.LOADING;
                break;

            case constants.CONVERT_STUDENT_PASSPORT_SUCCESS:
                draft.studentChangePassportStatus = LOADING_STATUSES.SUCCESS;
                draft.currentPassportChangeStudentIndex = null;
                break;

            case constants.CONVERT_STUDENT_PASSPORT_ERROR:
                draft.studentChangePassportStatus = LOADING_STATUSES.ERROR;
                draft.currentPassportChangeStudentIndex = null;
                break;

            case constants.SET_STUDENT_VALIDATION:
                const { id, value } = action;
                draft.migratingStudents[id] = value;

            // no default
        }
    });

export default reducer;
